export default {

    methods: {

        parseFloatFromString( float ) {

            if( typeof( float ) === 'string' ) float = float.replace( ',', '' );

            return parseFloat( float );
        },
        numberFormat(number) {
            return numeral(number).format('0,0.00');
        },
        thousandsFormat(number) {
            return numeral(number).format('0,0');
        },
        percentageFormat(number) {
            return numeral(number).format('0.00%');
        },
        moneyFormat(number, sign='$') {
            return sign + this.numberFormat(number);
        },
        phoneFormat(number) {
            let str = number.toString();
            let matched = str.match(/\d+\.?\d*/g);

            // 10 digit
            if (matched.length === 3) {
                return '(' + matched[0] + ') ' + matched[1] + '-' + matched[2];
                // 7 digit
            } else if (matched.length === 2) {
                return matched[0] + '-' + matched[1];
            }
            // no formatting attempted only found integers (i.e. 1234567890)
            else if (matched.length === 1) {
                // 11+ digit (Country code and number)
                if (matched[0].length > 10) {
                    return '+' + matched[0].substr(0, 1) + ' (' + matched[0].substr(1, 3) + ') ' + matched[0].substr(4, 3) + '-' + matched[0].substr(7);
                }
                // 10 digit (National number)
                if (matched[0].length === 10) {
                    return '(' + matched[0].substr(0, 3) + ') ' + matched[0].substr(3, 3) + '-' + matched[0].substr(6);
                }
                // 7 digit (Local number)
                if (matched[0].length === 7) {
                    return matched[0].substr(0, 3) + '-' + matched[0].substr(3);
                }
            }

            // Format failed, return number back
            return number;
        }
    }
}
